import gql from "graphql-tag";
import { Footprint } from "../../api/schema";

export interface FootprintListResponse {
  footprints: Array<Footprint>;
}

export interface DeleteFootprintResponse {
  deleteFootprint: boolean;
}

export interface UpdateFootprintResponse {
  updateFootprint: { id: number };
}

export interface CreateFootprintResponse {
  createFootprint: { id: number };
}

export const FootprintListQuery = gql`
  query footprints {
    footprints {
      id
      name
      type
    }
  }
`;

export const UpdateFootprintMutation = gql`
  mutation updateFootprint($values: UpdateFootprintInput!) {
    updateFootprint(values: $values) {
      id
    }
  }
`;

export const CreateFootprintMutation = gql`
  mutation createFootprint($values: CreateFootprintInput!) {
    createFootprint(values: $values) {
      id
    }
  }
`;

export const DeleteFootprintMutation = gql`
  mutation deleteFootprint($id: ID!) {
    deleteFootprint(id: $id)
  }
`;
